module.exports = __webpack_public_path__ + "images/img_IP_1-e624b2c431.png";